<template>
  <div class="wrapper pointer" @click="viewUnread()">
    <img class="icon" src="@/assets/icons/notice.png" alt="消息通知" />
    <span class="text">消息通知</span>
    <div class="msg_num" v-show="num!=0">
      <span>{{num}}</span>
    </div>
  </div>
</template>

<script>
import { trackEvent, EVENT_CODE } from "@/js/analytics";

export default {
  components: {},
  props: {},
  data() {
    return {
    };
  },
  watch: {},
  computed: {
    num(){
      return this.$store.state.unreadNum;
    }
  },
  methods: {
    viewUnread() {
      trackEvent(EVENT_CODE.PAGE_MESSAGE_NOTIFICATION, {
        path: this.$route.path,
        name: this.$route.name,
        source: 'header_notice',
        timestamp: Date.now()
      });
      // 去中转页面重定向绕过重复路由错误
      if (this.$route.name == "Message") {
        this.$router.replace({
          name: "Redirect",
          params: {
            name: "Message",
            params: {
              unread: false
            }
          }
        });
      } else {
        this.$router.push({
          name: "Message",
          params: {
            unread: false
          }
        });
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  margin-right: 16px;
  margin-left: 8px;
  color: #ffffff;
  white-space: nowrap;
}
.icon {
  width: 18px;
  height: 20px;
  margin-right: 6px;
}
.text {
  font-size: 14px;
  margin-right: 4px;
}
.msg_num {
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  width: 16px;
  height: 12px;
  background-color: #f26828;
  border-radius: 6px;
  span {
    display: flex;
    color: #fff;
    font-size: 12px;
    transform: scale(0.74, 0.74);
  }
}
</style>